/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endlunch1Inputs */

const en__field_endlunch1 = /** @type {(inputs: _Field_Endlunch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunchbreak end`)
};

const de__field_endlunch1 = /** @type {(inputs: _Field_Endlunch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagspause Ende`)
};

/**
* | output |
* | --- |
* | "Lunchbreak end" |
*
* @param {_Field_Endlunch1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_endlunch1 = /** @type {((inputs?: _Field_Endlunch1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endlunch1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_endlunch1(inputs)
	return de__field_endlunch1(inputs)
});
export { _field_endlunch1 as "_field_endLunch" }